import React, { useEffect, useState } from "react";
import Lottie from "lottie-react";

import animationEmtpyData from "../../assets/elements/empty-box.json";
import animationEmtpyItem from "../../assets/elements/empty-cart.json";

const ConditionalRender = ({
    productsData,
    children,
    isLoading = true,
    model,
}) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const timeout = setTimeout(() => {
            setIsVisible(true);
        }, 1000);

        return () => clearTimeout(timeout);
    }, []);

    if (isLoading) {
        return (
            <div className="flex flex-col items-center justify-center max-h-72 h-96 w-full">
                <div
                    role="status"
                    className="flex items-center justify-center h-full w-full bg-gray-200 dark:bg-[#1b2c46]  animate-pulse "
                >
                    <span className="sr-only">Loading...</span>
                </div>
            </div>
        );
    } else {
        if (productsData.length === 0) {
            return !isVisible ? (
                <div className="flex flex-col items-center justify-center max-h-72 h-96 w-full">
                    <div
                        role="status"
                        className="flex items-center justify-center h-full w-full bg-gray-200  dark:bg-[#1b2c46] animate-pulse "
                    >
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            ) : (
                <div className="flex flex-col items-center justify-center max-h-72 h-96 w-full">
                    <Lottie
                        animationData={
                            model === "emptyData"
                                ? animationEmtpyData
                                : model === "emptyItem"
                                    ? animationEmtpyItem
                                    : model === "emptyForm"
                                    ? animationEmtpyData
                                    : animationEmtpyItem
                        }
                        loop={true}
                        autoplay={true}
                        className="h-full max-h-32 "
                    />
                    <span className="text-sm ">
                        {model === "emptyData"
                            ? "Data Tidak Ditemukan"
                            : model === "emptyItem"
                                ? "Produk Gangguan"
                                : model === "emptyForm"
                                ? "Form Tidak Ditemukan"
                                : ""}
                    </span>
                </div>
            );
        } else {
            return <>{children}</>;
        }
    }
};

export default ConditionalRender;
